module.exports = __webpack_public_path__ + "img/thumb_aula25.9f3652a8.jpg";